import { restoreCheckoutCart } from 'actions/CheckoutActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import uuidV4 from 'lib/string/uuidV4Utils'
import { useEffect, useMemo } from 'react'
import { getSavedCheckoutReduxCartState } from 'storage/checkout'

export function useRestoreCartState() {
  const dispatch = useAppDispatch()
  const isCartRestored = useAppSelector(state => state.checkout.isCartRestored)
  const isAbandonedCart = useAppSelector(state => state.checkout.cart.isAbandonedCart)
  const isSpoofed = useAppSelector(state => state.auth.account.isSpoofed)
  const route = useAppSelector(state => state.router.location.pathname)

  const isCheckoutPage = useMemo(() => {
    return route.includes('checkout')
  }, [route])

  useEffect(() => {
    // Restore cart, if timestamp is older than 30 min, generate new transaction id
    // so the svc-cart won't get duplicated abandoned cart ids.
    if (isCheckoutPage && (!isCartRestored || isAbandonedCart)) {
      const { value: cartState, timestamp } = getSavedCheckoutReduxCartState()
      const isOlderThan30Min = !timestamp || Date.now() - timestamp > 30 * 60 * 1000
      dispatch(restoreCheckoutCart({
        ...cartState,
        ...(cartState && isOlderThan30Min && { transactionKey: uuidV4() }),
      }))
    }
  }, [dispatch, isCartRestored, isAbandonedCart, isCheckoutPage])

  useEffect(() => {
    if (!isCheckoutPage && isSpoofed) {
      const { value: cartState } = getSavedCheckoutReduxCartState()
      if (cartState) {
        dispatch(restoreCheckoutCart(cartState))
      }
    }
  }, [dispatch, isCheckoutPage, isSpoofed])
}
